import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, ArrowUpRight } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_web-instructions-3/artifacts/3j0ga580_Milet%20%2830%29.png";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-cobalt text-cream">
      <div className="mx-auto max-w-[1500px] px-6 py-14 md:px-10 md:py-20">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <img src={LOGO} alt="Milet" className="h-24 w-auto md:h-32" />
            <p className="mt-6 max-w-md font-chunk text-2xl italic text-cream md:text-3xl">
              Real grain. Real milk. Real loud.
            </p>
          </div>

          <div>
            <p className="font-sans text-[11px] font-extrabold uppercase tracking-[0.22em] text-butter">
              The Site
            </p>
            <ul className="mt-4 space-y-2 font-sans text-lg font-semibold">
              <li>
                <Link to="/" data-testid="footer-link-home" className="hover:text-butter">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/what-is-millet" data-testid="footer-link-what-is-millet" className="hover:text-butter">
                  The OG Supergrain
                </Link>
              </li>
              <li>
                <Link to="/why-millets" data-testid="footer-link-why-millets" className="hover:text-butter">
                  Millets Vs Everything
                </Link>
              </li>
              <li>
                <Link to="/blog" data-testid="footer-link-blog" className="hover:text-butter">
                  Journal
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <p className="font-sans text-[11px] font-extrabold uppercase tracking-[0.22em] text-butter">
              Get At Us
            </p>
            <ul className="mt-4 space-y-3 font-sans text-lg font-semibold">
              <li className="flex items-start gap-2">
                <Mail size={18} className="mt-1 shrink-0" />
                <a href="mailto:hello@milet.ca" data-testid="footer-email" className="hover:text-butter">
                  hello@milet.ca
                </a>
              </li>
              <li>Toronto, Canada</li>
              <li className="flex gap-3 pt-2">
                <a
                  href="#"
                  data-testid="footer-social-instagram"
                  aria-label="Instagram"
                  className="inline-flex items-center gap-1 rounded-full border-2 border-cream px-4 py-1.5 text-xs font-extrabold uppercase tracking-widest hover:bg-cream hover:text-jet"
                >
                  <Instagram size={14} /> @milet
                  <ArrowUpRight size={14} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* oversized marquee word */}
      <div className="select-none border-t-2 border-cream/20 overflow-hidden">
        <div
          className="flex whitespace-nowrap"
          style={{ animation: "marquee-x 60s linear infinite", width: "max-content" }}
        >
          {Array.from({ length: 3 }).map((_, i) => (
            <span
              key={i}
              className="font-chunk text-[20vw] leading-[0.9] text-butter pr-8"
            >
              milet · milet · milet ·{" "}
            </span>
          ))}
        </div>
      </div>

      <div className="border-t-2 border-cream/20 px-6 py-4 text-center text-[11px] font-extrabold uppercase tracking-[0.22em] text-cream/70">
        © {new Date().getFullYear()} Milet.ca — made with millet, in Canada
      </div>
    </footer>
  );
}
